import {Injectable} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {InputQuestion} from '../models/inputField';
import * as _ from 'lodash';

export class FormBaseService {
    private _form: any;
    private _formBase: any;
    formBuilder: any = new FormBuilder();
    private _ready: boolean = false;

    constructor(form = {}) {
        this._formBase = form;
        this._form     = this.createForm(form);
    }

    get form(): FormGroup {
        return this.sanitizeForm();
    }

    get formBase() {
        return this._formBase;
    }

    get questionnaire(){
        return this._formBase
    }

    set validator(validators) {
        _.mapKeys(validators, (v, k) => {
            return this._form.controls[k].setValidators(_.flatten([this.formBase[k].validators, v]));
        });
    }

    createForm(questionForm) {
        let form = this.formBuilder.group({});
        _.forEach(questionForm,  (value: any, key: any) => {
            if (value.isParent) {
                let group = this.createForm(_.omit(value, ['isParent']));
                form.addControl(key, group);
            } else {
                let newControl: FormControl = new FormControl();
                value.validators && newControl.setValidators(value.validators);
                form.addControl(key, newControl);

            }
        });
        return form;
    }

    addControl(inputQuestion: InputQuestion){
        this._formBase[inputQuestion.key] = inputQuestion;
        let newControl: FormControl = new FormControl();
        inputQuestion.validators && newControl.setValidators(inputQuestion.validators);
        this._form.addControl(inputQuestion.key, newControl);
        return true
    }

    sanitizeForm() {
        _.forEach(this._formBase, (value: any, key: any) => {
            if (value.escape) {
                this.escapeControl(key, value.escape);
            }
        });
        return this._form;
    }

    escapeControl(controlKey, escape) {
        _.forEach(escape, (escapeKey) => {
            if (this._form.controls[controlKey].value)
                this._form.controls[controlKey].setValue(_.replace(this._form.controls[controlKey].value, new RegExp(escapeKey, 'g'), ''));
        });

    }

    get ready(){
        return this._ready
    }

    setValidator(validatorFn) {
        this._form.setValidators(validatorFn);
    }

    handleFormControl(controlItem: InputQuestion | string, control: FormControl) {
        controlItem = _.isString(controlItem)
            ? <InputQuestion> this.questionnaire[controlItem]
            : controlItem;

        if (controlItem.parent) {
            this._form.controls[controlItem.parent].setControl(controlItem.key, control);
        } else {
            this._form.setControl(controlItem.key, control);
        }
    }

    clearForm(){
        this._form.reset();
    }

    formValid() {
        if (this._form && this._form.valid && this._form.touched) {
            return true;
        } else {
            return false;
        }
    }

    static createGenericForm(keys, type: string = 'string'){
        let formQuestion = {};
        _.forEach(keys, (key) => {
            formQuestion[key] = FormBaseService.createGenericInputQuestion(key, type)
        });
        return formQuestion
    }

    static createGenericInputQuestion(key, type): InputQuestion {
        return new InputQuestion({
            key: key,
            label: key,
            type: type,
            required: true,
            order: 1,
            readonly: false
        })
    }

    initForm(form) {
        this._formBase = form;
        this._form     = this.createForm(form);
        this._ready    = true;
        return this;
    }

}
